import React, { useEffect, useState } from 'react'
import { GGButton } from '../../shared/new_components/GGButton'
import { GGAlert } from '../../shared/new_components/GGAlert'
import ManagersTable from '../components/settings/managers_table'
import AddManagerPopup from '../components/settings/add_manager_popup'
import { useDispatch, useSelector } from 'react-redux'
import GgGolfHubPopupNotification from '../components/shared/gg_golf_hub_popup_notification'
import { addManager, deleteManager, reinviteManager } from '../actions/settings/managers_index'

const ERROR_AUTO_HIDE_DELAY = 5000

const GgGolfHubSettingsComponent = () => {
  const dispatch = useDispatch()
  const [isOpenManagerPopup, setIsOpenManagerPopup] = useState(false)
  const [isOpenNotificationPopup, setIsOpenNotificationPopup] = useState(false)
  const [notificationText, setNotificationText] = useState('')
  const [ errorMessage, setErrorMessage ] = useState(null)
  const [ isSubmitting, setIsSubmitting ] = useState(false)
  const managers = useSelector(state => state.managers)

  useEffect(() => {
    if (!errorMessage) { return }
    const timer = setTimeout(() => setErrorMessage(null), ERROR_AUTO_HIDE_DELAY)
    return () => clearTimeout(timer)
  }, [ errorMessage ])

  const notifyResult = (promise, onSuccess) => (
    promise
      .then(data => {
        if (onSuccess) { onSuccess() }
        setErrorMessage(null)
        setNotificationText(data.message)
        setIsOpenNotificationPopup(true)
      })
      .catch(error => setErrorMessage(error))
  )

  const handleReinvite = (userId) => notifyResult(dispatch(reinviteManager(userId)))

  const handleDelete = (userId) => notifyResult(dispatch(deleteManager(userId)))

  const handleAddManager = (firstName, lastName, email) => {
    if (isSubmitting) { return }
    setIsSubmitting(true)
    notifyResult(dispatch(addManager(firstName, lastName, email)), () => setIsOpenManagerPopup(false))
      .finally(() => setIsSubmitting(false))
  }
  
  return (
    <div className='hub-settings'>
      <AddManagerPopup key={isOpenManagerPopup} isOpen={isOpenManagerPopup} isSubmitting={isSubmitting} handleAddManager={handleAddManager} handleOnClose={() => setIsOpenManagerPopup(false)}/>
      <GgGolfHubPopupNotification
        isOpen={isOpenNotificationPopup}
        text={notificationText}
        onClose={() => setIsOpenNotificationPopup(false)} />
      {errorMessage && <GGAlert variant='error' message={errorMessage} className='hub-settings-error-alert'/>}
      <div className='top-bar'>
        <h3 className='text-ds-h3'>{window.I18n.t('gg_golf_hub.settings.managers')}</h3>
        <GGButton
          label={window.I18n.t('gg_golf_hub.settings.add_manager')}
          icon='square-plus-o'
          onClick={() => setIsOpenManagerPopup(true)}
        />
      </div>
      <ManagersTable managers={managers} handleReinvite={handleReinvite} handleDelete={handleDelete}/>
    </div>
  )
}


export default GgGolfHubSettingsComponent
